if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        document.querySelectorAll('.quick-add__submit').forEach(btn => {
          btn.disabled = true;
        });
        const GIFT_CARD_HANDLE = 'gift-card';
        const formData = new FormData(this.form);
        const productHandle = this.dataset.handle || window.location.pathname.split('/').pop();
        const isGiftCard = productHandle.includes(GIFT_CARD_HANDLE);

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // 🟢 Add section info for cart-drawer update
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const clearCart = async () => {
          await fetch('/cart/clear.js', { method: 'POST' });
        };

        const addToCart = async (formData) => {
          config.body = formData;
          const response = await fetch(`${routes.cart_add_url}`, config);
          return response.json();
        };

        const updateCartButtons = async () => {
          const cartRes = await fetch('/cart.js');
          const cartData = await cartRes.json();
          const hasGiftCard = cartData.items.some(i => i.handle.includes(GIFT_CARD_HANDLE));

          const giftCardBtns = document.querySelectorAll('.gift-cart-atc');
          const regularBtns = document.querySelectorAll('.product-form__buttons');

          if (hasGiftCard) {
            regularBtns.forEach(btn => {
              btn.disabled = true;
            });
            giftCardBtns.forEach(btn => {
              btn.disabled = false;
            });
          } else {
            regularBtns.forEach(btn => {
              btn.disabled = false;
            });
            giftCardBtns.forEach(btn => {
              btn.disabled = false;
            });
          }

          // 🟡 Update sold-out buttons for quick-add
          cartData.items.forEach(item => {
            if (item.handle === 'gift-card') return;
            setTimeout(() => {
              let productButtons = document.querySelectorAll(`.quick-add__submit-${item.id}`);
              productButtons.forEach(productAtc => {
                if (productAtc) {
                  const currentQuantity = parseInt(productAtc.dataset.productQuantity, 10);
                  if (currentQuantity === item.quantity) {
                    const soldOutMsg = productAtc.querySelector('.sold-out-message');
                    productAtc.querySelector('span').classList.add('hidden');
                    if (soldOutMsg) soldOutMsg.classList.remove('hidden');
                    productAtc.setAttribute('aria-disabled', true);
                    productAtc.classList.add('disabled');
                  }
                }
              });
            }, 2000);
          });
        };

        fetch('/cart.js')
          .then(res => res.json())
          .then(async (cartData) => {
            const hasGiftCard = cartData.items.some(item => item.handle.includes(GIFT_CARD_HANDLE));
            const hasOtherProducts = cartData.items.some(item => !item.handle.includes(GIFT_CARD_HANDLE));

            // 🟢 Case 1: Adding gift card when cart has other products
            if (isGiftCard && hasOtherProducts) {
              const proceed = await window.showGiftcardPopup("Adding a gift card will remove your other items from the cart. Continue?");
              if (!proceed) {
                this.resetButtonState();
                return;
              }
              await clearCart();
            }

            // 🟡 Case 2: Adding other product when cart has gift card
            if (!isGiftCard && hasGiftCard) {
              const proceed = await window.showGiftcardPopup("A gift card is already in your cart. Remove it to add this product?");
              if (!proceed) {
                this.resetButtonState();
                return;
              }
              await clearCart();
            }

            const variantId = parseInt(formData.get('id'), 10);
            const existingItem = cartData.items.find(
              item => item.variant_id === variantId
            );

            const currentQty = existingItem ? existingItem.quantity : 0;
            const addingQty = parseInt(formData.get('quantity') || 1, 10);
            const maxQty = 5;

            if (currentQty + addingQty > maxQty) {
              this.handleErrorMessage(`You can only add maximum ${maxQty} quantities.`);
              this.resetButtonState();
              return;
            }

            return addToCart(formData);
          })
          .then((response) => {
            if (!response) return;

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.showSoldOutState();
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => this.cart.renderContents(response));
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            updateCartButtons();
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.resetButtonState();
            document.querySelector('cart-drawer-items')?.freeCartProduct?.();
            document.querySelectorAll('.quick-add__submit').forEach(btn => {
              btn.disabled = false;
              btn.classList.remove('loading');
            });
          });
      }

      showSoldOutState() {
        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
      }

      resetButtonState() {
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading__spinner').classList.add('hidden');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.error = false;
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      }

      handleErrorMessage(errorMessage = false, timeout = 80000) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (this.errorMessageTimeout) {
          clearTimeout(this.errorMessageTimeout);
        }

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          this.errorMessageTimeout = setTimeout(() => {
            this.errorMessageWrapper.setAttribute('hidden', true);
            this.errorMessage.textContent = '';
          }, timeout);
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


let lastScrollTop = 0;

document.addEventListener('scroll', function () {
  const scrollTop = window.scrollY;
  const container = document.querySelector('.quantity-selector--wrapper');
  const screenWidth = window.innerWidth;

  // Threshold based on screen width
  const threshold = screenWidth <= 989 ? 1150 : 480;

  if (scrollTop > lastScrollTop) {
    // 🔽 Scrolling DOWN → check threshold and add sticky
    if (scrollTop > threshold) {
      container?.classList.add('sticky');
    }
  } else {
    // 🔼 Scrolling UP → remove sticky
    container?.classList.remove('sticky');
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});


function handleSoldOutButtons() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cartData) => {
      // Get current variant quantities in cart
      const cartMap = new Map();
      cartData.items.forEach((item) => {
        cartMap.set(item.variant_id, item.quantity);
      });

      // Find all quick-add buttons on page
      const productButtons = document.querySelectorAll('[class*="quick-add__submit-"]');

      productButtons.forEach((button) => {
        if (button.dataset.isGiftCard === 'true') return;
        // Extract variant ID from class like quick-add__submit-123456789
        const match = button.className.match(/quick-add__submit-(\d+)/);
        if (!match) return;

        const variantId = parseInt(match[1], 10);
        const maxQty = parseInt(button.dataset.productQuantity, 10);
        const cartQty = cartMap.get(variantId) || 0;

        const soldOutMsg = button.querySelector('.sold-out-message');
        const addToCartText = button.querySelector('span:not(.sold-out-message)');

        const inventoryPolicy = button.dataset.inventoryPolicy;


        if (inventoryPolicy !== "continue" && cartQty >= maxQty) {
          // Mark as sold out
          if (addToCartText) addToCartText.classList.add('hidden');
          if (soldOutMsg) soldOutMsg.classList.remove('hidden');
          button.setAttribute('aria-disabled', true);
          button.classList.add('disabled');
        } else {
          // Make available to add
          if (addToCartText) addToCartText.classList.remove('hidden');
          if (soldOutMsg) soldOutMsg.classList.add('hidden');
          button.removeAttribute('aria-disabled');
          button.classList.remove('disabled');
        }
      });
    });
}

const cartDrawer = document.querySelector('cart-drawer');

if (cartDrawer) {
  const observer = new MutationObserver(() => {
    handleSoldOutButtons(); // Trigger when DOM inside cart drawer changes
  });

  observer.observe(cartDrawer, { childList: true, subtree: true });
}